import { connect } from 'react-redux';
import { setCurrentTab } from 'store/siteCoordinator/siteCoordinator.actions';
import { setCurrentGenres, requestGenresPodcastStart } from 'store/podcast/podcast.actions';

const mapStateToProps = (state) => ({
    podcastState: state.podcast,
});

const mapDispatchToProps = (dispatch) => ({
    onSetCurrentTab: (value) => dispatch(setCurrentTab(value)),
    onSetGenres: (value) => dispatch(setCurrentGenres(value)),
    onRequestGenresPodcast: (genresId, currentPage) => dispatch(requestGenresPodcastStart(genresId, currentPage)),
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
